export default {
  sarPathAiReady: '',
  sarAiAnnotationsStatus: false,
  sarPageLimit: 10
}